import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/marketplace/relatedBySeller';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';

// "More from this provider" strip on the listing detail page.
// Failures are SOFT (the section just doesn't render) — no global
// Error dispatch, matching the old component-side soft-fail.
function* process(action) {
  const { sellerUid, sellerScope } = action.payload || {};
  try {
    const params = new URLSearchParams({
      seller_uid:   sellerUid,
      sort_by:      'subscribers',
      sort_order:   'desc',
      limit:        '12',
    });
    if (sellerScope) params.set('seller_scope', sellerScope);
    const response = yield call(
      axios.get,
      `${config.API_URL}/marketplace/listings?${params.toString()}`,
      { headers: getLocalUser() },
    );
    const items = response?.data?.data?.listings || response?.data?.listings || [];
    yield put(fetchSuccess(items));
  } catch (error) {
    yield put(fetchFailure(extractErrorMessage(error)));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, process);
}
